import { render, staticRenderFns } from "./TrustButton.vue?vue&type=template&id=474b9c73&"
import script from "./TrustButton.vue?vue&type=script&lang=js&"
export * from "./TrustButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports